import { createAction, handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/recruitWrite";

const RECRUIT_WRITE = "recruit/RECRUIT_WRITE"; // 비회원 모집정보 등록
const RECRUIT_WRITE_SUCCESS = "recruit/RECRUIT_WRITE_SUCCESS";
const RECRUIT_MEMBER = "recruit/RECRUIT_MEMBER"; // 회원 모집정보 등록
const RECRUIT_MEMBER_SUCCESS = "recruit/RECRUIT_MEMBER_SUCCESS";
// const RECRUIT_WRITE_PENDING = "recruit/RECRUIT_WRITE_PENDING";
// const RECRUIT_WRITE_SUCCESS = "recruit/RECRUIT_WRITE_SUCCESS";

const RECRUIT_TITLE = "recruit/RECRUIT_TITLE"; // 모집정보 타이틀
const RECRUIT_TITLE_PENDING = "recruit/RECRUIT_TITLE_PENDING";
const RECRUIT_TITLE_SUCCESS = "recruit/RECRUIT_TITLE_SUCCESS";

const FORM_DATA = "recruit/FORM_DATA"; // 모집정보 신청시 체크한 값 저장
const SET_ERROR = "recruit/SET_ERROR";
const STEP_NEXT = "recruit/STEP_NEXT";

export const recruitWrite = createPromiseThunk(RECRUIT_WRITE, api.recruitWrite);
export const recruitWriteTitle = createPromiseThunk(
  RECRUIT_TITLE,
  api.recruitWriteTitle
);
export const recruitMemberWrite = createPromiseThunk(
  RECRUIT_MEMBER,
  api.recruitMemberWrite
);
export const formData = createAction(FORM_DATA);
export const setError = createAction(SET_ERROR, msg => msg);
export const stepNext = createAction(STEP_NEXT, type => type);

const initialState = {
  data: {},
  titleData: null,
  error: null,
  nextPage: 1
};

export default handleActions(
  {
    [RECRUIT_TITLE_PENDING]: (state, { payload }) => ({
      ...state,
      titleData: null
    }),
    [RECRUIT_TITLE_SUCCESS]: (state, { payload }) => ({
      ...state,
      titleData: payload.data.data
    }),
    [RECRUIT_WRITE_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: {}
    }),
    [RECRUIT_MEMBER_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: {}
    }),
    [FORM_DATA]: (state, { payload }) => ({
      ...state,
      data: { ...state.data, ...payload }
    }),
    [SET_ERROR]: (state, { payload }) => ({
      ...state,
      error: payload
    }),
    [STEP_NEXT]: (state, { payload }) => ({
      ...state,
      nextPage: payload
    })
  },
  initialState
);
